// PricingPage — full-page catalog (checkout cancel / direct /pricing). Org billing opens
// the same catalogs in PlansTopupsModal instead of navigating here.
import {
  BillingCycleToggle,
  PlansCatalog,
  SalesSeatModal,
  TopupCatalog,
  usePricingCatalog,
} from '@/features/billing/pricingCatalog';
import '@/features/billing/plans-topups-modal.css';

export default function PricingPage() {
  const catalog = usePricingCatalog(true);

  return (
    <div className="container">
      <div className="text-center mb-5">
        <h1 className="h2 mb-3">Choose your plan</h1>
        <p className="text-muted">
          Bring your own API keys — pay Quralyst for the intelligence layer.
        </p>
        <div className="mt-3">
          <BillingCycleToggle catalog={catalog} />
        </div>
      </div>

      <PlansCatalog catalog={catalog} />

      {catalog.checkoutError && (
        <div className="alert alert-danger mt-4" id="checkoutError">
          {catalog.checkoutError}
        </div>
      )}

      <hr className="my-5" />
      <div className="text-center mb-4">
        <h2 className="h2 mb-2">Need more credits?</h2>
        <p className="text-muted">
          One-time top-ups — never expire, consumed after your monthly plan credits.
        </p>
      </div>
      <TopupCatalog catalog={catalog} />
      <SalesSeatModal catalog={catalog} />
    </div>
  );
}
